"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toggleMenu = exports.openMenu = exports.closeAllMenuPages = exports.closeMenu = void 0;
var body = document.body;
var closeMenu = function () {
    if (!body.classList.contains('menu-open')) {
        return; // Already closed
    }
    // Close all menu pages if any are open
    if (body.classList.contains('menu-page-track-record-open') || body.classList.contains('menu-page-contact-open') || body.classList.contains('menu-page-broadcasts-open')) {
        (0, exports.closeAllMenuPages)();
        return;
    }
    // Change the Menu label to Menu
    var menuLabel = document.querySelector('.site-nav__menu__toggle__label');
    if (menuLabel) {
        menuLabel.textContent = 'Menu';
    }
    // Closing - add closing class for animation
    body.classList.add('menu-closing');
    // Wait for animation to finish before fully hiding
    setTimeout(function () {
        body.classList.remove('menu-closing');
        body.classList.remove('menu-open');
    }, 300); // Match the animation duration
    // body.classList.remove('menu-closing');
    // body.classList.remove('menu-open');
};
exports.closeMenu = closeMenu;
var closeAllMenuPages = function () {
    body.classList.remove('menu-page-track-record-open');
    body.classList.remove('menu-page-contact-open');
    body.classList.remove('menu-page-broadcasts-open');
};
exports.closeAllMenuPages = closeAllMenuPages;
var openMenu = function () {
    if (body.classList.contains('menu-open')) {
        return; // Already open
    }
    // Change the Menu label to Close
    var menuLabel = document.querySelector('.site-nav__menu__toggle__label');
    if (menuLabel) {
        menuLabel.textContent = 'Close';
    }
    body.classList.add('menu-open');
};
exports.openMenu = openMenu;
var toggleMenu = function () {
    if (body.classList.contains('menu-open')) {
        (0, exports.closeMenu)();
    }
    else {
        (0, exports.openMenu)();
    }
};
exports.toggleMenu = toggleMenu;
var handleNavColourChange = function () {
    var nav = document.querySelector('.site-nav');
    var scrollPosition = window.scrollY;
    if (scrollPosition > 100) {
        nav === null || nav === void 0 ? void 0 : nav.classList.add('nav-scrolled');
    }
    else {
        nav === null || nav === void 0 ? void 0 : nav.classList.remove('nav-scrolled');
    }
};
var handleMenuPages = function () {
    var hashLinks = document.querySelectorAll('a[href^="#open-track-record"], a[href^="#open-contact"], a[href^="#open-broadcast"]');
    hashLinks.forEach(function (hashLink) {
        hashLink.addEventListener('click', function (event) {
            event.preventDefault();
            var targetId = hashLink.getAttribute('href');
            if (targetId === null || targetId === void 0 ? void 0 : targetId.includes('#open-track-record')) {
                if (body.classList.contains('menu-page-track-record-open')) {
                    (0, exports.closeAllMenuPages)();
                    return;
                }
                else {
                    (0, exports.closeAllMenuPages)();
                    body.classList.toggle('menu-page-track-record-open');
                }
            }
            if (targetId === null || targetId === void 0 ? void 0 : targetId.includes('#open-broadcast')) {
                if (body.classList.contains('menu-page-broadcasts-open')) {
                    (0, exports.closeAllMenuPages)();
                    return;
                }
                else {
                    (0, exports.closeAllMenuPages)();
                    body.classList.toggle('menu-page-broadcasts-open');
                }
            }
            if (targetId === null || targetId === void 0 ? void 0 : targetId.includes('#open-contact')) {
                if (body.classList.contains('menu-page-contact-open')) {
                    (0, exports.closeAllMenuPages)();
                    return;
                }
                else {
                    (0, exports.closeAllMenuPages)();
                    body.classList.toggle('menu-page-contact-open');
                }
            }
        });
    });
    var closeMenuPageButtons = document.querySelectorAll('.site-overlay');
    closeMenuPageButtons.forEach(function (closeMenuPageButton) {
        closeMenuPageButton.addEventListener('click', function (event) {
            event.preventDefault();
            (0, exports.closeAllMenuPages)();
        });
    });
};
var initNav = function () {
    var toggle = document.querySelector('.site-nav__menu__toggle');
    toggle === null || toggle === void 0 ? void 0 : toggle.addEventListener('click', exports.toggleMenu);
    handleNavColourChange(); // Initial check
    window.addEventListener('scroll', handleNavColourChange);
    handleMenuPages();
};
document.addEventListener('DOMContentLoaded', initNav);
